import React from 'react';

export type Props = {
  isBadgeHidden?: boolean;
};

export const HiddenGoogleRecaptcha = React.memo((props: Props) => {
  const { isBadgeHidden } = props;

  return (
    <>
      {isBadgeHidden && (
        <style jsx>
          {`
          .grecaptcha-badge {
            visibility: hidden;
          }
        `}
        </style>
      )}
    </>
  );
});

HiddenGoogleRecaptcha.displayName = 'HiddenGoogleRecaptcha';
